import { ActionContext } from "vuex";
import { IAuthState } from "./state";
import { IRootState } from "../../types";
import { IAuthModel } from "@/interfaces/modules/authetication/IAutheticationModel";
import router from "@/router";
import Api from "@/api/Authentication/AuthenticationService";
import HttpClient from "@/api/Client/HttpClient";
import { toAppError } from "@/utils/http-error";
import store from "@/store";

export interface IAuthActions {
  login(context: ActionContext<IAuthState, IRootState>, data: IAuthModel): void;
  logout(
    context: ActionContext<IAuthState, IRootState>,
    notReload: boolean
  ): void;
}

export const AuthActions: IAuthActions = {
  async login(
    { commit }: ActionContext<IAuthState, IRootState>,
    { Email, Password, vm }: IAuthModel
  ) {
    try {
      const res = await Api.login({ Email, Password } as IAuthModel);
      //debugger;
      console.log(res);
      if (res.Message == "OK") {
        commit("CHANGE_IS_AUTHENTICATED", true);
        commit("SET_TOKEN", res.Token);
        commit("SET_MENU", res.Result.Menu);
        commit("SET_PATHS", res.Result.Paths);
        commit("SET_USERNAME", res.Result.UserName);
        commit("SET_CURUSER_OBJECT", res.Result);
        commit("SET_SYSTEMUSERS", res.Result.SystemUsers);

        HttpClient.defaults.headers.common["Authorization"] =
          "Bearer " + res.Token;
        router.push("Home");
      }
    } catch (err: any) {
      const appErr = toAppError(err);
      store.dispatch("core/popupDialog", {
        text: `Error: ${appErr.message}`,
        type: "error",
        showCancelButton: false,
      });
    }
  },
  async logout(
    { commit }: ActionContext<IAuthState, IRootState>,
    notReload: boolean
  ) {
    commit("CHANGE_IS_AUTHENTICATED", false);
    commit("SET_TOKEN", null);
    commit("SET_MENU", []);
    commit("SET_SYSTEMUSERS", []);
    commit("SET_PATHS", []);
    commit("SET_USERNAME", null);
    commit("SET_CURUSER_OBJECT", null);
    router.push("Login");
    if (!notReload) location.reload();
  },
};
